import { render, staticRenderFns } from "./CommonMask.vue?vue&type=template&id=6325dd4a&scoped=true"
import script from "./CommonMask.vue?vue&type=script&lang=js"
export * from "./CommonMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6325dd4a",
  null
  
)

export default component.exports